var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreUSureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1483 3.25236C22.6084 2.77786 23.3545 2.77786 23.8146 3.25236L26.1234 5.63332L28.4322 3.25239C28.8923 2.77788 29.6383 2.77788 30.0984 3.25239C30.5586 3.72689 30.5586 4.49621 30.0984 4.97072L27.7896 7.35165L30.0984 9.73256C30.5585 10.2071 30.5585 10.9764 30.0984 11.4509C29.6383 11.9254 28.8923 11.9254 28.4321 11.4509L26.1234 9.06998L23.8146 11.4509C23.3545 11.9254 22.6085 11.9254 22.1483 11.4509C21.6882 10.9764 21.6882 10.2071 22.1483 9.73259L24.4571 7.35165L22.1483 4.97069C21.6882 4.49619 21.6882 3.72687 22.1483 3.25236Z",
    fill: "#4D6D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2844 21.2001L21.5689 21.9769C21.5689 21.9769 19.8682 23.8234 15.226 18.7833C10.5837 13.7432 12.2845 11.8967 12.2845 11.8967L12.735 11.4075C13.845 10.2024 13.9496 8.26763 12.9812 6.85516L11.0003 3.96581C9.80167 2.21759 7.48556 1.98665 6.11174 3.47822L3.64595 6.15536C2.96475 6.89495 2.50826 7.85368 2.56362 8.91723C2.70524 11.6381 3.83269 17.4924 10.1238 24.3227C16.7954 31.5661 23.0552 31.854 25.615 31.5934C26.4247 31.511 27.1288 31.0607 27.6963 30.4446L29.9279 28.0217C31.4343 26.3862 31.0096 23.5823 29.0822 22.4383L26.0808 20.6568C24.8153 19.9056 23.2734 20.1262 22.2844 21.2001Z",
    fill: "#4D6D9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreUSureIcon);
export default __webpack_public_path__ + "static/media/AreUSureIcon.4ccb06b068e67fa16686c23896baeca6.svg";
export { ForwardRef as ReactComponent };